export default __webpack_public_path__ + "static/quadrant-text-regular-fd0b74eae1a9a3c3cb96e10aba92cc0d.ttf";